




























# import settings from '@/settings'
import t from '@/utils/tools'
import Menus from '@/components/menus'

export default {
    name: 'company_abs_tel'

    components: { Menus }

    watch:
        '$route': (route_to, route_from)->
            # console.log "WATCH ROUTE", route_to,
            if route_to.name == 'company_abs_tel'
                @define_route()

    data: ()->
        head_title: ''
        # absences_accesses: ['absences_show','telework_show','oncall_duties_show']
        absences_accesses: ['absences_show','telework_show']
        # absences_routes: ['company_absences','company_telework','company_oncall_duties']
        absences_routes: ['company_absences','company_telework']

    methods:
        has_access_right: t.has_access_right
        absences_title: t.absences_title

        define_route: ()->
            if @$route.params.direct and @has_access_right(@$route.name.split('_')[1]+'_show')
                return
            for index, a of @absences_accesses
                if @has_access_right(a)
                    @$router.push({name:@absences_routes[index]})
                    .catch (err)-> {}
                    break
        
    beforeMount: ()->
        @head_title = @absences_title(@absences_accesses)
        @define_route()
}

